import { focusCameraSelectCard } from '@/components/globalCameraStreamWidget/cameraSelector/useCameraSelectorGamepadWindowEvents/useCameraSelectorGamepadWindowEvents.functions.ts';

import {
  activeSiteTabPanelCameraCardSelector,
  getActiveSiteTabPanelCameraSelectCardByIdSelector,
} from './cameraSelector.constants.ts';

export const focusInitialCameraSelectCard = (preferredCameraId?: string) => {
  const preferredCard = preferredCameraId
    ? document.querySelector<HTMLButtonElement>(
        getActiveSiteTabPanelCameraSelectCardByIdSelector(preferredCameraId)
      )
    : null;

  // Preferred camera when switching streams; otherwise the first card in the active site tab.
  const target =
    preferredCard ??
    document.querySelector<HTMLButtonElement>(activeSiteTabPanelCameraCardSelector);
  if (!target) return;
  focusCameraSelectCard(target);
};
